import Vue from 'vue'
import Router from 'vue-router'
import {usersCollection, mainAuth} from '@/FirebaseConfig' 
Vue.use(Router)
const router= new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:customerName?',
      component: ()=>import('@/views/home/views/Home'),
      
      children:[
        { 
          path: 'cotizar/:idProveedor?/:idCotizacion?',
          name: 'proveedor_cotizacion',
          component: ()=> import('./views/cotizaciones/vistas/proveedor/Proveedor_cotizacion'),
        },
        {
          path:'orden_de_compra/:idOrdenCompra',
          name:'Orden_de_compra',
          component:()=> import('./views/cotizaciones/vistas/proveedor/Orden_de_compra'),
        },
        {
          path: '',
          name: 'logIn',
          component: ()=>import('@/views/home/views/LogIn'),
        },
        {
          path: 'activar-cuenta/',
          name: 'signUp',
          component: () => import('./views/home/views/SignUp')
        },
        {
          path:'app',
          component: ()=>import('@/views/main/views/main'),
          children:[
            {
              path:'panel-de-control',
              component: () => import('./views/settings/settings'),
              children: [
                {
                  path: 'customers',
                  name: 'general',
                  component: ()=>import('./views/settings/views/Customers'),
                  meta: {
                    requiresAuth: true
                  }
                },
                {
                  path:'usuarios',
                  name:'users',
                  component:() => import('./views/settings/views/Users'),
                  meta: {
                    requiresAuth: true,
                    privileges: "users",
                  },
                },
                {
                  path:'clientes',
                  name:'clients',
                  component:()=> import('./views/settings/views/Clients'),      
                  meta: {
                    requiresAuth: true,
                    privileges: 'clients'
                  },
                },
                {
                  path: 'tipos-de-usuario',
                  name: 'userTypes',
                  component: () => import('./views/settings/views/UserTypes'),
                  meta: {
                    requiresAuth: true,
                    privileges: 'clients'
                  },
                },
                {
                  path: 'productos',
                  name: 'products',
                  component: () => import('./views/settings/views/Products'),
                  meta: {
                    requiresAuth: true,
                    privileges: 'products'
                  } ,  
                },
                {
                  path: 'tipo-de-producto',
                  name: 'productType',
                  component: () => import('./views/settings/views/ProductsTypes'),
                  meta: {
                    requiresAuth: true,
                    privileges: 'productType'
                  },
                },
                {
                  path: 'almacenes',
                  name: 'warehouse',
                  component: () => import('./views/settings/views/Warehouse'),
                  meta: {
                    requiresAuth: true,
                    privileges: 'warehouse'
                  },
                },
                {
                  path:'proveedores',
                  name:'suppliers',
                  component: () => import('./views/settings/views/Suppliers'),
                  meta: {
                    requiresAuth: true,
                    privileges: 'suppliers'
                  },
                },  
                {
                  path:'documentos',
                  name:'receiptType',
                  component: () => import('./views/settings/views/Documents'),
                  meta: {
                    requiresAuth: true,
                    privileges: 'receiptType'
                  },
                },
                {
                  path:'operaciones',
                  name:'operations',
                  component: () => import('./views/settings/views/Operations'),
                  meta: {
                    requiresAuth: true,
                    privileges: 'operations'
                  },
                },
                {
                  path:'privilegios',
                  name:'privileges',
                  component: () => import('./views/settings/views/Privileges'),
                  meta: {
                    requiresAuth: true,
                    privileges: 'privileges'
                  },
                },
                {
                  path:'motivos-de-traslado',
                  name:'motivos-de-traslado',
                  component: () => import('./views/settings/views/Motivos_de_traslado'),
                  meta: {
                    requiresAuth: true,
                    privileges: 'privileges'
                  },
                },
                {
                  path:'Transportista',
                  name:'transportista',
                  component:()=>import('./views/settings/views/Transportista'),
                  meta:{
                  requiresAuth: true,
                  privileges: 'transportista',
                  },
                },
                {
                  path: 'correo-remitente',
                  name: 'correoRemitente',
                  component:()=>import('./views/settings/views/correo_remitente'),
                  meta:{
                    requiresAuth: true,
                    privileges: 'correoRemitente',
                  },
                },
                {
                  path:'Trabajadores',
                  name:'trabajadores',
                  component:()=> import('./views/settings/views/Trabajadores'),
                  meta:{
                    requiresAuth: true,
                    privileges: 'trabajadores',
                  }
                },
              ]
            },
      
            {
              path: 'ventas',
              name: 'sales',
              component: () => import('./views/sales/views/Sales'),
              meta: {
                requiresAuth: true,
                privileges: 'sales'
              }
            },
            {
              path:'Configuraciones',
              name:'configuration',
              component:()=> import('./views/settings/views/settings'),
              meta: {
                requiresAuth: true,
              }
            },
            {
              path:'entradas',
              name:'inputs',
              component: () => import('./views/entradas/vistas/Inputs'),
              meta: {
                requiresAuth: true,
                privileges: 'inputs'
              },
            },
            {
              path:'salidas',
              name:'outputs',
              component: () => import('./views/salidas/vistas/Outputs'),
              meta: {
                requiresAuth: true,
                privileges: 'outputs'
              },
            },
            {
              path:'kardex',
              name:'kardex',
              component: () => import('./views/inventory/views/Kardex'),
              meta: {
                requiresAuth: true,
                privileges: 'kardex'
              },
            }, 
            {
              path:'existencias',
              name:'stock',
              component: () => import('./views/inventory/views/Stock'),
              meta: {
                requiresAuth: true,
                privileges: 'stock'
              },
            },
            {
              path:'aprobaciones',
              name:'aprobaciones',
              component: () => import('./views/aprobacion/index'),
              meta: {
                requiresAuth: true,
                privileges: 'aprobaciones'
              },
            },
            {
              path:'MediosDePago',
              name:'paymentsMethods',
              component:()=> import('./views/settings/views/PaymentsMethods'),
              meta: {
                requiresAuth: true,
                privileges: 'paymentsMethods',
              }
            },
          
            {
              path: 'TiposDeDocumento',
              name: 'documentTypes',
              component: ()=> import('./views/settings/views/DocumentTypes'),
              meta: {
                requiresAuth: true,
                privileges: 'documentTypes'
              }
            },
            {
              path: 'Partidas_Contables',
              name: 'partidas_contables',
              component: ()=> import('./views/contable/vistas/Contable'),
              meta: {
                requiresAuth: true,
                privileges: 'partidas_contables'
              }
            },
            {
              path: 'Cotizaciones',
              name: 'cotizaciones',
              component: ()=> import('./views/cotizaciones/vistas/usuario/Cotizaciones'),
              meta: {
                requiresAuth: true,
                privileges: 'cotizaciones'
              },
            },
            {
              path: 'Naturaleza_contable',
              name: 'naturaleza_contable',
              component: ()=> import('./views/contable/vistas/Naturaleza_contable'),
              meta: {
                requiresAuth: true,
                privileges: 'naturaleza_contable'
              }
            },
            { 
              path: 'credenciales',
              name: 'credenciales',
              component: ()=> import('./views/settings/views/Credenciales'),
              meta: {
                requiresAuth: true,
                privileges: 'credenciales'
              }
            },
            {
              path: 'libro_mayor',
              name: 'libro_mayor',
              component: ()=> import('./views/contable/vistas/Libro_mayor'),
              meta: {
                requiresAuth: true,
                privileges: 'libro_mayor'
              }
            },
            {
              path: 'cuenta_por_pagar',
              name: 'cuenta_por_pagar',
              component: ()=> import('./views/contable/vistas/Cuentas_por_pagar'),
              meta: {
                requiresAuth: true,
                privileges: 'cuenta_por_pagar'
              }
            },
            {
              path: 'balance_general',
              name: 'balance_general',
              component: ()=> import('./views/contable/vistas/Balance_general'),
              meta: {
                requiresAuth: true,
                privileges: 'balance_general'
              }
            },
            {
              path: 'contable',
              name: 'contable',
              component: ()=> import('./views/contable/vistas/Conjunto'),
              meta: {
                requiresAuth: true,
                privileges: 'contable'
              }
            },
            {
              path: 'resumen',
              name: 'resumen',
              component: ()=> import('./views/contable/vistas/Resumen_partida')
            }
          ]
        }  
        
      ]
    },
  ]
})
router.beforeEach(async (to,from,next)=>{
  const currentUser =   mainAuth.currentUser
  const requiresAuth = to.matched.some(record=> record.meta.requiresAuth)
  const requiredPrivilege = to.matched.map(item => item.meta.privileges).filter(item => item!=undefined)
  if(requiresAuth && !currentUser) next ({name:'logIn', params: {customerName: router.history.current.params.customerName }})
  if(requiredPrivilege.length>0 && !currentUser) next ({name:'logIn', params: {customerName: router.history.current.params.customerName  }})
  if(requiredPrivilege.length>0 && currentUser){ 
    const currentUserEmail = mainAuth.currentUser.email
    const lookingForUser = await usersCollection.where('email', '==', currentUserEmail).get()


    if (lookingForUser.empty) {
      mainAuth.signOut().then(()=>{ next ({name: 'logIn', params: {customerName: router.history.current.params.customerName  }}) })
    } else {
      const userPrivilegesList = lookingForUser.docs[0].data().privileges
      if (userPrivilegesList.indexOf(requiredPrivilege[0])>-1) {
        next ( )
      } else {
        next ({name:'stock', params: {customerName: router.history.current.params.customerName}} )
      }
    }
  }
  else next()
})
export default router